import { render, staticRenderFns } from "./PartyCharacteristics.vue?vue&type=template&id=ff898e06&scoped=true&"
import script from "./PartyCharacteristics.vue?vue&type=script&lang=js&"
export * from "./PartyCharacteristics.vue?vue&type=script&lang=js&"
import style0 from "./PartyCharacteristics.vue?vue&type=style&index=0&id=ff898e06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff898e06",
  null
  
)

export default component.exports